/** Refresh after returning from Stripe; allow a bounded window for its webhook. */
export function watchBillingRefresh(refresh: () => void | Promise<void>) {
  const timers = new Set<ReturnType<typeof setTimeout>>();
  let checkoutPending =
    new URLSearchParams(window.location.search).get("checkout") === "success";
  const clear = () => {
    timers.forEach(clearTimeout);
    timers.clear();
  };
  const onReturn = () => {
    void refresh();
    if (!checkoutPending) return;
    clear();
    [2000, 5000, 10000, 20000].forEach((delay) => {
      const timer = setTimeout(() => {
        timers.delete(timer);
        void refresh();
      }, delay);
      timers.add(timer);
    });
    checkoutPending = false;
  };
  const onCheckout = () => {
    checkoutPending = true;
  };
  window.addEventListener("focus", onReturn);
  window.addEventListener("pageshow", onReturn);
  window.addEventListener("billing-status-changed", onReturn);
  window.addEventListener("billing-checkout-opened", onCheckout);
  if (checkoutPending) onReturn();
  return () => {
    clear();
    window.removeEventListener("focus", onReturn);
    window.removeEventListener("pageshow", onReturn);
    window.removeEventListener("billing-status-changed", onReturn);
    window.removeEventListener("billing-checkout-opened", onCheckout);
  };
}
